import React from "react";

const VarietyHead = ({ linkCode, variety, varieties }) => {
    const linkedVariety = varieties.find((v) => v.value === linkCode);

    return (
        <div className="variety-head">
            <div className="input-group -no-margin">{variety}</div>
            <br />
            {linkedVariety && (
                <div>
                    Linked To:
                    <br />
                    <strong>{linkedVariety.text}</strong>
                </div>
            )}
        </div>
    );
};

export default VarietyHead;
